document.addEventListener("DOMContentLoaded", function(event) {
    let swiperSelector = document.querySelectorAll('[data-preview-presents]');
    if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
        return;

    swiperSelector.forEach(el => {
        let previewPresents = new Swiper(el, {
            effect: 'coverflow',
            loop: true,
            centeredSlides: true,
            slidesPerView: 2,
            keyboardControl: true,
            mousewheelControl: true,
            lazyLoading: true,
            preventClicks: false,
            preventClicksPropagation: false,
            lazyLoadingInPrevNext: true,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 250,
                modifier: 1,
            },
            breakpoints: {
                980: {
                    slidesPerView: 3,
                    coverflowEffect: {
                        depth: 400
                    }
                }
            },
            autoplay: {
                delay: 4000,
                pauseOnMouseEnter: true
            },
        });
    });
});